module.exports = __webpack_public_path__ + "static/media/earning_campaign_type.d55ac2c2.png";